/* eslint-disable no-restricted-globals */
/* eslint-disable prefer-promise-reject-errors */
export default {
    required: {
        required: true,
        message: 'Ce champ est requis.',
    },
    number: {
        validator: (_, value) => (!isNaN(value)
            ? Promise.resolve()
            : Promise.reject(
                'Please provide a valid phone number.',
            )),
    },
    email: {
        type: 'email',
        message: 'Veuillez entrer une adresse e-mail valide.',
    },
};
